<template>
    <app-content>
        <app-content-body>
            <div class="inner">
                <p class="buttons">
                    <a
                        class="btn btn_action btn_add"
                        :title="translations.addBackoffice"
                        @click.prevent="createItem"
                    ></a>
                </p>
                <h1 v-translate>Vazby na Backoffice</h1>
            </div>
            <app-table
                clickable
                deletable
                highlight-rows-on-hover
                :data="items"
                :order="params.order"
                :page-size="params.limit"
                :loading="listLoading"
                @sort="sortItems"
                @rowClick="goToDetail"
                @deleteRow="deleteItem"
            >
                <app-table-column first sortable attribute="name" :label="translations.name">
                    <template slot-scope="row">
                        <strong>
                          {{ row.name }}
                        </strong>
                    </template>
                </app-table-column>
                <app-table-column attribute="apiUrl" :label="translations.apiUrl">
                    <template slot-scope="row">
                        {{ row.apiUrl }}
                    </template>
                </app-table-column>
                <app-table-column sortable attribute="updated" :label="translations.updated">
                    <template slot-scope="row">
                        <div v-html="formatDate(row._updated)" />
                    </template>
                </app-table-column>

                <template slot="footer" v-if="itemsMetadata.totalCount > params.limit">
                  <app-table-pagination
                      :page="listPage"
                      :itemsPerPage="params.limit"
                      :totalCount="itemsMetadata.totalCount"
                      @pageChanged="tablePageChanged"
                  />
                </template>
            </app-table>
        </app-content-body>
    </app-content>
</template>
<script>
import getItemsListMixin from 'mixins/getItemsListMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'

const itemsListMixin = getItemsListMixin({
  apiMethodsSuffix: 'Backoffices',
  detailRouteName: 'backoffice'
})

export default {
    name: 'backoffices',
    mixins: [formatDateMixin, itemsListMixin, appTitleMixin()],
    computed: {
        translations() {
          return {
            addBackoffice: this.$gettext('Přidat Backoffice'),
            name: this.$gettext('Název'),
            apiUrl: this.$gettext('API Url'),
            updated: this.$gettext('Upraveno'),
          }
        },
        currentTitle() {
            return [
                this.$gettext('Vazby na Backoffice')
            ]
        },
    }
}
</script>
